/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ComplianceTimelineEventPayload } from './';
import {
    ComplianceTimelineEventPayloadFromJSON,
    ComplianceTimelineEventPayloadFromJSONTyped,
    ComplianceTimelineEventPayloadToJSON,
} from './';

/**
 * 
 * @export
 * @interface UmbrellaEventTimelinePayload
 */
export interface UmbrellaEventTimelinePayload extends ComplianceTimelineEventPayload {
    /**
     * 
     * @type {string}
     * @memberof UmbrellaEventTimelinePayload
     */
    umbrellaCompanyId: string;
    /**
     * 
     * @type {string}
     * @memberof UmbrellaEventTimelinePayload
     */
    umbrellaCompanyName?: string;
}

/**
 * Check if a given object implements the UmbrellaEventTimelinePayload interface.
 */
export function instanceOfUmbrellaEventTimelinePayload(value: object): value is UmbrellaEventTimelinePayload {
    if (!('umbrellaCompanyId' in value) || value['umbrellaCompanyId'] === undefined) return false;
    return true;
}

export function UmbrellaEventTimelinePayloadFromJSON(json: any): UmbrellaEventTimelinePayload {
    return UmbrellaEventTimelinePayloadFromJSONTyped(json, false);
}

export function UmbrellaEventTimelinePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): UmbrellaEventTimelinePayload {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadFromJSONTyped(json, ignoreDiscriminator),
        'umbrellaCompanyId': json['umbrellaCompanyId'],
        'umbrellaCompanyName': json['umbrellaCompanyName'] == null ? undefined : json['umbrellaCompanyName'],
    };
}

export function UmbrellaEventTimelinePayloadToJSON(value?: UmbrellaEventTimelinePayload | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadToJSON(value, true),
        'umbrellaCompanyId': value['umbrellaCompanyId'],
        'umbrellaCompanyName': value['umbrellaCompanyName'],
    };
}

